import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import services from 'services';

const useRouteChange = () => {
  // workaround: we need to re-dispatch hashchange event when route changes,
  // otherwise microfrontend modules won't be notified about the route change
  const location = useLocation();
  const locationRef = useRef(location);
  useEffect(() => {
    if (locationRef.current.pathname === location.pathname) {
      return;
    }

    // when navigation happens, close all errors
    services.appFrame.error.main.closeAllErrors();

    window.dispatchEvent(
      new HashChangeEvent('hashchange', {
        newURL: location.pathname,
        oldURL: locationRef.current.pathname,
      }),
    );
    locationRef.current = location;
  });

  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;
  useEffect(() => {
    // @ts-expect-error
    return services.appFrame._router.onRouteChange((url) => {
      navigateRef.current(url);
    });
  }, [navigate]);
};

export default useRouteChange;
